<template>
  <article
    class="group relative flex h-full flex-col"
    :class="[$style.cardContainer]"
    data-spec="product-card-content"
  >
    <div class="mb-auto p-16" data-spec="main">
      <slot name="tag" />

      <div class="flex">
        <div
          class="flex max-w-full grow content-start justify-center gap-8"
          :class="[
            $style.cardWrapper,
            {
              [$style.isBackbox]: product.rawProduct.granularity === 'backbox',
              'flex-row-reverse items-start': format === 'compact',
              'flex-col-reverse': format !== 'compact',
            },
          ]"
          data-spec="image+main-information"
        >
          <div
            class="flex min-w-0 grow flex-col items-start gap-6"
            data-spec="product-info"
          >
            <div class="flex flex-col gap-2 max-w-full" data-spec="titles">
              <slot name="titles-first-row" />
              <h3>
                <slot name="titles-second-row" />
              </h3>
              <slot name="titles-third-row" />
            </div>

            <slot name="product-info" />
          </div>

          <div
            class="flex flex-col items-center justify-center gap-4 shrink-0"
            data-spec="image+colors"
          >
            <slot name="image" />
          </div>
        </div>
      </div>
    </div>

    <ProductComparisonCheckbox
      v-if="comparison?.isComparisonEnabled"
      class="absolute bottom-8 right-8 lg:bottom-auto lg:top-8"
      :is-checked="isProductCompared"
      :is-comparison-add-disabled="
        comparison.isComparisonAddProductDisabled ?? false
      "
      :is-responsive-comparison-enabled="
        comparison.isResponsiveComparisonEnabled ?? false
      "
      @change="emit('toggle-comparison-product', product.listingId)"
    />

    <slot name="footer" />
  </article>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import ProductComparisonCheckbox from '../ProductComparison/components/ProductComparisonCheckbox.vue'

import type { Comparison, ProductCardProduct } from './ProductCard.types'

const { comparison, product } = defineProps<{
  product: ProductCardProduct
  format?: 'default' | 'compact'
  comparison?: Comparison
}>()

const emit = defineEmits(['toggle-comparison-product'])

const isProductCompared = computed(() => {
  return (
    comparison?.comparisonProducts?.some(
      (p) => p.listingId === product.listingId,
    ) || false
  )
})
</script>

<style module>
.cardContainer {
  container-type: inline-size;
  container-name: product-card;
}

@container product-card (width > 326px) {
  .cardWrapper:not(.isBackbox) {
    flex-direction: row-reverse;
  }
}
</style>
